import * as Sentry from '@sentry/vue'

// services
import cookie from '@/services/cookie'
import sib from '@/services/sib'
import zoho from '@/services/zoho'
import mixpanelUtils from '@/utils/mixpanel.utils'

// api
import UserApi from '@/api/user'
import AccountApi from '@/api/account'
// utils
import utils from '@/util'

// constants
import constants from '@/constant'

// 3rd-parties
import sentry from '@/services/sentry'

const { gaCategories } = constants

const setCurrentUserAction = async ({ commit }, payload) => {
  commit('setCurrentUser', payload)
}

const setPlan = async ({ commit }, payload) => {
  commit('setPlan', payload)
}

const getCurrentUserAction = async ({ commit, state }) => {
  let { currentUser } = state

  try {
    // phải lấy profile 2 lần nếu k thì k thì có bug khi signup từ form ở trang chủ
    // http://localhost:8080/pages/token?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzU
    // sImlhdCI6MTYzMjIxODAyNiwiZXhwIjoxNjk1MjkwMDI2fQ.dOpl8ICE7i-2624J5pmVQJdO4mcBpUgJkE
    // 7UkvZAlOI&signup=1&name=loi&email=stove+102test@gmail.com
    if (!currentUser.id) {
      currentUser = await UserApi.getUser()
    }
  } catch (error) {
    commit('setIsServerConnectable', false)

    utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'User > Load > Failed')
    throw error
  }

  currentUser.rememberSettings = currentUser.rememberSettings || {}
  if (currentUser.accountId) {
    try {
      const currentAccount = await AccountApi.getAccountById(currentUser.accountId)
      if (!currentAccount.id) currentAccount.id = 0
      commit('setCurrentAccount', currentAccount)
    } catch (error) {
      if (error.status === 403) {
        commit('setCurrentAccount', {})
      }
    }
  }
  if (currentUser.id && currentUser.plan !== 'white-label') {
    currentUser.isPlayingDemoEnabled = false
    if (!currentUser.playedPresentationIds ||
      (currentUser.playedPresentationIds && !currentUser.playedPresentationIds.length)) {
      currentUser.isPlayingDemoEnabled = true
    }
  }
  // Handle default open participant view when go to editor first time
  try {
    const timeEnableFeature = 1654067127535 // 14:05 01/06/2022
    if (currentUser.id && currentUser.id % 4 === 3) {
      const userCreatedAt = new Date(currentUser.createdAt).getTime()
      if (timeEnableFeature < userCreatedAt) {
        if (!currentUser.personalInformation) currentUser.personalInformation = {}
        if (typeof (currentUser.personalInformation.isFirstTimeShowParticipantView) !== 'boolean') {
          currentUser.personalInformation.isFirstTimeShowParticipantView = true
          UserApi.patchUserById(currentUser.id, {
            personalInformation: currentUser.personalInformation,
          })
        }
      }
    }
  } catch {
    Sentry.captureException('Check A/B participant view error')
  }

  // store user id into for logging purpose
  cookie.setValue('aha-user-id', currentUser.id)
  cookie.setValueByDomain('aha-user-id', currentUser.id)

  sentry.identifyUser(currentUser)
  sib.identifyUser(currentUser)
  zoho.identifyUser(currentUser)

  // TODO: should simplify with one funcion call like above
  mixpanelUtils.identify(currentUser)

  // mixpanelUtils.track('Access presenter app')

  commit('setCurrentUser', currentUser)
  commit('setPlan', currentUser.plan)

  return currentUser
}

const setCurrentUserHasCreatedPresentationAction = async ({ commit, state }) => {
  const userHasCreatedPresentation = state.currentUser.personalInformation &&
        state.currentUser.personalInformation.hasCreatedPresentation

  if (!userHasCreatedPresentation) {
    const res = await UserApi.patchUserById(state.currentUser.id, {
      personalInformation: {
        ...state.currentUser.personalInformation,
        hasCreatedPresentation: true,
      },
    })
    commit('setHasOnboardingV3', false)
    commit('setCurrentUser', res.body)
  }
}

export default {
  getCurrentUserAction,
  setCurrentUserAction,
  setPlan,
  setCurrentUserHasCreatedPresentationAction,
}
